$(document).ready(function() {

  $('.reviewBox').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
  });


  $('.as_featured_inner').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });


  $('.icon_with_text_inner').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });




  $('.marquee_text').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });


  $('.header_topbar_main').marquee({
    direction: 'left',
    duration: 13000,
    delayBeforeStart: 0,
    pauseOnHover: true,
    duplicated: true,
    startVisible: true
  });



$('.product_ipsy_inner').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1281,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

});


//   // currency dropdown
// setTimeout(() => {
//   const currencyToggle = document.querySelector(".js-dropdown-toggle");

//   if (!currencyToggle) return;

//   currencyToggle.addEventListener("click", (e) => {
//     console.log(e)
//     // e.preventDefault();

//     const menu = e.currentTarget
//       .closest(".currency-dropdown")
//       .querySelector(".currency-menu");

//     const isOpen = menu.classList.contains("open");
//     menu.classList.toggle("open", !isOpen);
//     menu.style.display = isOpen ? "none" : "flex";
//   });

// }, 500);
